interface ChartIconStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const ChartIconStatic = ({
  width = 24,
  height = 24,
  className,
  color = 'currentColor',
  strokeWidth = 2
}: ChartIconStaticProps) => {
  return (
    <div className={className} style={{ width, height }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
      >
        {/* axes */}
        <path d="M3 3v16a2 2 0 0 0 2 2h16" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />

        {/* right bar */}
        <rect x="15" y="5" width="4" height="12" rx="1" stroke={color} strokeWidth={strokeWidth} />

        {/* left bar */}
        <rect x="7" y="8" width="4" height="9" rx="1" stroke={color} strokeWidth={strokeWidth} />
      </svg>
    </div>
  );
};


